import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import ExtraFunctionEntrance from './components/ExtraFunctionEntrance';

export interface NavbarProps {
  title?: ReactNode;
  bgColor?: string;
  fontColor?: string;
  btnColor?: string;
  backUrl?: string;
  onBack?: () => void;
  showRightBtn?: boolean;
}
// 使用传统函数声明代替箭头函数，兼容ES2015
function Navbar(props: NavbarProps) {
  // 使用传统方式解构对象，避免使用解构赋值语法
  const title = props.title;
  const bgColor = props.bgColor;
  const fontColor = props.fontColor;
  const btnColor = props.btnColor;
  const backUrl = props.backUrl;
  const onBack = props.onBack;
  const showRightBtn = props.showRightBtn;
  const navigate = useNavigate();

  return (
    <div
      className="navbar"
      style={{
        backgroundColor: bgColor || '#fff',
        padding: '13px',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <i
        className="back-btn"
        style={{ color: btnColor || '#333', width: '20px', height: '20px' }}
        onClick={function () {
          if (backUrl) {
            window.location.href = backUrl;
          } else if (typeof onBack === 'function') {
            onBack();
          } else {
            history.go(-1);
          }
        }}
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" fillRule="evenodd">
            <path d="M0 0h20v20H0z" />
            <path
              stroke={btnColor || '#333'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M13 17l-7-7 7-7"
            />
          </g>
        </svg>
      </i>
      <i
        className="exit-btn"
        style={{ color: btnColor || '#333', marginLeft: '25px' }}
        onClick={function () {
          localStorage.removeItem('workbench_active_tab');
          // 使用条件检查代替可选链操作符
          if (window && window.app && window.app.postMessage) {
            window.app.postMessage(
              JSON.stringify({
                function: 'exit'
              })
            );
          }
        }}
      >
        <svg
          className="icon"
          width="20"
          height="20"
          style={{
            verticalAlign: 'middle',
            overflow: 'hidden'
          }}
          viewBox="0 0 1035 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill={btnColor || '#333'} fillRule="evenodd">
            <path
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M868.248009 806.105382c17.398599 17.398599 17.398599 45.612844 0 63.011443-8.699299 8.699299-20.105295 13.054519-31.500152 13.054519s-22.800853-4.355219-31.500152-13.054519L517.491363 581.360484 229.735022 869.116825c-8.699299 8.699299-20.105295 13.054519-31.500153 13.054519s-22.800853-4.355219-31.500152-13.054519c-17.398599-17.398599-17.398599-45.612844 0-63.011443l287.745203-287.756341-287.756342-287.756342c-17.398599-17.398599-17.398599-45.612844 0-63.011443s45.612844-17.398599 63.011444 0l287.756341 287.756341 287.745203-287.745203c17.398599-17.398599 45.612844-17.398599 63.011443 0s17.398599 45.612844 0 63.011444L580.491668 518.360179l287.756341 287.756342z"
            ></path>
          </g>
        </svg>
      </i>
      <div
        className="title"
        style={{
          color: fontColor || '#333',
          fontSize: '20px',
          fontWeight: 'bold',
          margin: '0 auto',
          paddingRight: '48px'
        }}
      >
        {title}
      </div>
      {showRightBtn && (
        <div className="right-btn">
          <img
            style={{ width: '20px', height: '20px' }}
            onClick={() => {
              navigate('/general-transport/settings');
            }}
            src={require('@/assets/images/multiVehicle/setting-icon.png')}
          ></img>
        </div>
      )}
      {/* 三个点的入口（存放额外功能） */}
      <ExtraFunctionEntrance />
    </div>
  );
}

export default Navbar;
